import React from 'react';

const AdminBulkPreview = ({ items, getKey, getName, getMeta, noun }) => {
  const extra = items.length - 5;
  return (
    <div className="admin-bulk-list">
      {items.slice(0, 5).map((item) => (
        <div key={getKey(item)} className="admin-bulk-item">
          <div className="admin-bulk-name">{getName(item)}</div>
          {getMeta ? <div className="admin-bulk-meta">{getMeta(item)}</div> : null}
        </div>
      ))}
      {extra > 0 && (
        <div className="admin-bulk-more">
          ... and {extra} more {noun}{extra > 1 ? 's' : ''}
        </div>
      )}
    </div>
  );
};

export default AdminBulkPreview;
